<script>
	let url = "https://contao49.mike.fm-media-staging.at";

	let lokalTokenContao49 = "807c122222c9981120cebcd86282c9fa";

	const myHeaders = new Headers();

	myHeaders.append('Content-Type', 'application/json');
	myHeaders.append('Authorization', lokalTokenContao49);
	myHeaders.append('Access-Control-Allow-Origin', '*');

	const getContaoVersion = async () => fetch(`${url}/contao-manager.phar.php/api/server/contao`, {
		method: 'GET',
		headers: myHeaders,
	})
	.then(function (response) {
		console.log(response.status);
		return response.text();
	}).then(function (data) {
		console.log(data);
	})
	.catch(function (error) {
		console.log(error.message);
	});
</script>

<a href={`${url}/contao-manager.phar.php/#oauth?scope=admin&client_id=FMmediaMonitoringClient&return_url=http://localhost:5000`}>addWeb</a>

<button on:click={getContaoVersion}>getContaoVersion</button>

<style>

</style>